import { Grid, GridSize, makeStyles } from "@material-ui/core";
import * as React from "react";
import { useSelector } from "react-redux";
import { filterList } from "../../helper/search-helper";
import { Filters } from "../../model/search-base-model";
import { AppState, SearchState } from "../../model/state-models";

interface SearchListProps {
  renderItem: (item: any) => JSX.Element;
  xs?: GridSize;
  sm?: GridSize;
  md?: GridSize;
}

const groupBy = function (xs, key) {
  if (!xs) {
    return {};
  }
  return xs?.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

const useStyles = makeStyles({
  center: {
    textAlign: "center",
  },
});

export function MenuList(props: SearchListProps) {
  const classes = useStyles();
  const state = useSelector<AppState<any>, SearchState<any>>(
    (state) => state?.searchState
  );
  const filters = useSelector<AppState<any>, Filters>(
    (state) => state?.searchState.filters
  );
  const filtered = filterList(state?.initialItems, filters);
  const grouped = groupBy(filtered, "groupText");
  return (
    <>
      {Object.keys(grouped)?.map((key) => (
        <div key={key}>
          <div className={classes.center}>
            <h2>{key}</h2>
            {grouped[key][0]?.sectionDescription && (
              <p>{grouped[key][0]?.sectionDescription}</p>
            )}
          </div>

          <Grid container>
            {grouped[key]?.map((item) => (
              <Grid
                container
                justifyContent="center"
                key={item?.id}
                item
                xs={props?.xs}
                sm={props?.sm}
                md={props?.md}
              >
                {props?.renderItem(item)}
              </Grid>
            ))}
          </Grid>
        </div>
      ))}
    </>
  );
}

MenuList.defaultProps = {
  xs: 12,
  sm: 6,
  md: 4,
};
